import { StyledCMSParagraphComponent } from './CMSParagraphComponent.styles';
import useResponsive from '@hooks/useResponsive';

type CmsParagraphComponentProps = {
  data: CmsParagraphComponentType;
  isStorePage?: boolean;
};

const CMSParagraphComponent = ({ data, isStorePage }: CmsParagraphComponentProps) => {
  const { content } = data;
  const { fromDesktop } = useResponsive();
  const showComponent = isStorePage ? fromDesktop : true;
  return showComponent ? (
    <StyledCMSParagraphComponent
      paddingBottom={data.paddingBottom}
      paddingLeft={data.paddingLeft}
      paddingTop={data.paddingTop}
      paddingRight={data.paddingRight}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  ) : null;
};

export default CMSParagraphComponent;
